export const POST_VACCINATION_REACTIONS_CSV = `code,Поствакцинальные реакции,Post-vaccination reactions
skinReactions,Кожные реакции,Skin reactions
redness,Покраснение,Redness
swelling,Припухание,Swelling
induration,Уплотнение,Induration
warmth,Чувство тепла,Warmth
skinUrticaria,Крапивница,Urticaria
skinItching,Зуд,Itching
localEdema,Отёк местный,Local edema
skinRash,Кожная сыпь,Skin rash
keloidScar,Келоидный рубец,Keloid scar
abscess,Абсцесс,Abscess
soreness,Болезненность,Soreness
generalReactions,Общие реакции,General reactions
jointPain,Суставная боль,Joint pain
musclePain,Мышечная боль,Muscle pain
headache,Головная боль,Headache
fever,Лихорадка,Fever
temperatureElevation,Подъём температуры,Temperature elevation
chills,Озноб,Chills
sweating,Потоотделение,Sweating
weakness,Слабость,Weakness
slowedReaction,Заторможенность реакции,Slowed reaction
generalMalaise,Общее недомогание,General malaise
generalFainting,Обморок,Fainting
nausea,Тошнота,Nausea
vomiting,Рвота,Vomiting
allergicReactions,Аллергические реакции,Allergic reactions
urticaria,Крапивница,Urticaria
itching,Зуд,Itching
generalEdema,Отёк общий,General edema
anaphylacticShock,Анафилактический шок,Anaphylactic shock
allergicShortnessOfBreath,Одышка,Shortness of breath
allergicSuffocation,Удушье,Suffocation
respiratoryReactions,Респираторные реакции,Respiratory reactions
nasalDischarge,Выделения из носа,Nasal discharge
nasalCongestion,Заложенность носа,Nasal congestion
voiceChange,Изменение качества голоса,Voice change
cough,Кашель,Cough
shortnessOfBreath,Одышка,Shortness of breath
chokingSensation,Ощущение удушья,Choking sensation
stridor,Стридор,Stridor
wheezing,Хрипы,Wheezing
suffocation,Удушье,Suffocation
cardiovascularReactions,Сердечно-сосудистые реакции,Cardiovascular reactions
bradycardia,Брадикардия,Bradycardia
hypotension,Гипотония,Hypotension
palpitations,Сердцебиение,Palpitations
tachycardia,Тахикардия,Tachycardia
pallor,Бледность,Pallor
fainting,Обморок,Fainting`;
